import { render, staticRenderFns } from "./MyTickets.vue?vue&type=template&id=5b16b13f&scoped=true&"
import script from "./MyTickets.vue?vue&type=script&lang=js&"
export * from "./MyTickets.vue?vue&type=script&lang=js&"
import style0 from "./MyTickets.vue?vue&type=style&index=0&id=5b16b13f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b16b13f",
  null
  
)

export default component.exports